<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            style="height: 100%"
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <div class="carInsBtn">
              <el-row>
                <el-col class="carInsHeadLeft" :span="12">
                  <span>{{ $t("TerminalCommand.terminalType") }}</span>
                </el-col>
                <el-col class="carInsHeadRight" :span="12">
                  <span>
                    <i
                      @click="addType"
                      style="cursor: pointer"
                      class="el-icon-plus"
                    ></i>
                    <i
                      @click="deleteType"
                      style="cursor: pointer"
                      class="el-icon-delete"
                    ></i>
                  </span>
                </el-col>
              </el-row>
            </div>
            <div class="carInsList">
              <el-scrollbar>
                <el-radio-group
                  @change="ChangTerminal"
                  style="width: 100%"
                  v-model="typeId"
                >
                  <el-radio
                    v-for="item in terminalList"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.terminalType }}</el-radio
                  >
                </el-radio-group>
              </el-scrollbar>
            </div>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
         
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-btn">
                <el-button
                  type="text"
                  :disabled="selected.length == 0"
                  @click="editCommand"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  type="text"
                  :disabled="selected.length == 0"
                  @click="deleteCommand"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button type="text" @click="addCommand">{{
                  $t("common.btn.add")
                }}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="terminalType"
            :label="$t('TerminalCommand.terminalModel')"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.terminalType"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="productKey"
            :label="$t('TerminalCommand.productNumber')"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.productKey"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeCommandDia"
        class="addDialong"
        :title="diaCommandTitle"
        :visible.sync="dialogCommandFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="CommandRules" ref="CommandForm" :model="CommandForm">
          <el-form-item
            prop="name"
            :label="$t('TerminalCommand.InsContent')"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="CommandForm.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="aliKey"
            :label="$t('TerminalCommand.InsIdentifier')"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="CommandForm.aliKey"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="keyType"
            :label="$t('TerminalCommand.InsType')"
            :label-width="formLabelWidth"
          >
            <el-select v-model="CommandForm.keyType" :placeholder="$t('TerminalCommand.choseTip')">
              <el-option :label="$t('TerminalCommand.attSetting')" value="1"></el-option>
              <el-option :label="$t('TerminalCommand.servSetting')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="sort"
            :label="$t('TerminalCommand.sort')"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              type="number"
              v-model="CommandForm.sort"
            
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="explain"
            :label="$t('TerminalCommand.Instructions')"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="CommandForm.explain"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="unit" :label="$t('TerminalCommand.unit')" :label-width="formLabelWidth">
            <el-input
              size="small"
              v-model="CommandForm.unit"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="isShow"
            :label="$t('TerminalCommand.isShow')"
            :label-width="formLabelWidth"
          >
            <el-select v-model="CommandForm.isShow" :placeholder="$t('common.form.choseTip')">
              <el-option :label="$t('TerminalCommand.hidden')" value="0"></el-option>
              <el-option :label="$t('TerminalCommand.show')" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleCommand('CommandForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitCommandForm('CommandForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TerminalCommand from "./TerminalCommand.js";
export default TerminalCommand;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
